import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { QueryKeys } from "./";
import { uiNotification } from "../../services/UINotificationService";
import { http } from "../../services/HttpService";
import { handleApiErrorMessage } from "../../utilities/api";

const GetResourceDetails = (id) => {
  const url = `/resources/${id}`;
  return http.get(url);
};

export const useGetResourceDetailsQuery = (id) => {
  return useQuery([QueryKeys.GET_NOTES_ACKNOWLEDGED_HISTORY, id], () =>
    GetResourceDetails(id),
  );
};

const UpdateResourceDetails = (payload) => {
  const { id, ...data } = payload;
  const url = `/resources/${id}`;
  return http.put(url, data);
};

export const useUpdateResourceDetailsQuery = (id) => {
  const queryClient = useQueryClient();
  return useMutation(UpdateResourceDetails, {
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [QueryKeys.GET_NOTES_ACKNOWLEDGED_HISTORY, id],
      });
    },
    onError: (error) => {
      uiNotification.error(handleApiErrorMessage(error));
    },
  });
};

const CreateNewResource = (data) => {
  const url = `/resources/0`;
  return http.post(url, data);
};

export const useCreateNewResourceQuery = () => {
  return useMutation(CreateNewResource, {
    onError: (error) => {
      uiNotification.error(handleApiErrorMessage(error));
    },
  });
};

const CreateNewResourceType = (data) => {
  const url = `/resource-types`;
  return http.post(url, data);
};

export const useCreateNewResourceTypeQuery = () => {
  return useMutation(CreateNewResourceType, {
    onError: (error) => {
      uiNotification.error(handleApiErrorMessage(error));
    },
  });
};

const DeleteResource = (id) => {
  const url = `/resources/${id}`;
  return http.delete(url);
};

export const useDeleteResourceQuery = () => {
  return useMutation(DeleteResource, {
    onError: (error) => {
      uiNotification.error(handleApiErrorMessage(error));
    },
  });
};
